import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import "react-quill/dist/quill.snow.css";

import ReactSummernote from "react-summernote";
import "react-summernote/dist/react-summernote.css";


import { editEmailTemplates } from "../actions/admin";
import toast from "react-hot-toast";
import $ from "jquery";
window.$ = window.jQuery = $;





const EditEmailTemplateModal = ({
  show,
  handleClose,
  record,
  getTemplates,
}) => {
  console.log(record, "record");

  const [formvalue, setFormvalue] = useState({});
  const [content, setContent] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    console.log(record, 'formvalue')
    setFormvalue(record);
  }, [record]);


  const handleChange = (e) => {
    try {
      let Formvalue = { ...formvalue }
      if (e.target && e.target.name == 'subject') {
        const { name, value } = e.target;
        Formvalue = { ...formvalue, [name]: value };
      }
      // else {
      //   // console.log(e, 'handleChange')
      //   // Formvalue = { ...formvalue, ['content']: e };
      //   setContent(e)
      // }
      setFormvalue(Formvalue)
      console.log(Formvalue, formvalue, "FormvalueFormvalueFormvalue")
    } catch (err) {
      console.log(err, "handleChange");
    }
  };

  const handleEdit = (e) => {
    try {
      setContent(e)
    } catch (err) {
      console.log(err, "handleChange");
    }
  }


  const handleSubmit = async () => {
    try {
      let data = {
        _id: record._id,
        identifier: formvalue.identifier,
        subject: formvalue.subject,
        content: content,
      };


      console.log(data, "datadatadatadata")



      let { status, message } = await editEmailTemplates(data);
      if (status) {
        toast.success(message);
        handleClose();
        getTemplates();
      } else {
        toast.error("Tempalte Updated Failed");
        handleClose();
        getTemplates();
      }
      handleClose();
      getTemplates();
    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };
  console.log(formvalue, content, 'handleEdit')
  return (
    <>
      <Modal
        centered
        className="cmn_modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="cmn_modal_header d-flex justify-content-between align-items-center mb-4">
            <p className="cmn_modal_title">Edit Template</p>
            <button
              className="cmn_modal_closer rounded-5"
              onClick={() => {
                handleClose();
              }}
            >
              <i class="fa-solid fa-xmark" />
            </button>
          </div>

          <div className="rp_singleinput_holder mb-3">
            <p className="rp_label mb-2">Identifier</p>
            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
              <input
                type="text"
                placeholder="Enter Identifier"
                className="rp_singleInput flex-grow-1"
                value={formvalue?.identifier}
                disabled
              />
            </div>
          </div>

          <div className="mt-4">
            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Subject</p>
              <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                <input
                  type="text"
                  placeholder="Enter Subject"
                  className="rp_singleInput flex-grow-1"
                  name="subject"
                  value={formvalue?.subject}
                  onChange={handleChange}
                />
              </div>
            </div>


            <div className="rp_singleinput_holder mb-3">
              <p className="rp_label mb-2">Content</p>
              {/* <div className="rp_input_holder rounded-2 px-0">
               
              </div> */}
              {/* <ReactQuill theme="snow" value={value} onChange={setValue} /> */}

              <div className="custom_reactSummerNote">
                <ReactSummernote
                  // value="Default text"
                  value={formvalue?.content}
                  name="content"
                  options={{
                    height: 250,
                    dialogsInBody: true,
                    toolbar: [
                      //   ["style", ["style"]],
                      ["font", ["bold", "underline", "clear"]],
                      //   ["fontname", ["fontname"]],
                      ["para", ["ul", "ol", "paragraph"]],
                      // ["table", ["table"]],
                      // ["insert", ["link", "picture", "video"]],
                      ["view", ["codeview"]],
                    ],
                  }}
                  onChange={handleEdit}
                />
              </div>
            </div>
            <button className="orange_small_primary mt-3"

              onClick={() => handleSubmit()}


            >Submit </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditEmailTemplateModal;
